import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Ubah Setting Invoice"),
      /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Manajemen data setting invoice")
    ])
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 fv-row" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Informasi Invoice")
], -1)
const _hoisted_8 = { class: "col-lg-6 fv-row" }
const _hoisted_9 = { class: "row px-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 fv-row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sekolah", -1)
const _hoisted_12 = ["label", "value"]
const _hoisted_13 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = {
  key: 1,
  class: "col-12 fv-row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Sekolah", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sekolah", -1)
const _hoisted_18 = ["label", "value"]
const _hoisted_19 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-12 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Produk", -1)
const _hoisted_23 = {
  key: 3,
  class: "fv-plugins-message-container"
}
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "col-12 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Produk", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Produk", -1)
const _hoisted_28 = ["label", "value"]
const _hoisted_29 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "col-12 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Default Price", -1)
const _hoisted_33 = { class: "col-lg-6 fv-row" }
const _hoisted_34 = { class: "row px-3" }
const _hoisted_35 = { class: "col-12 fv-row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Batas Waktu", -1)
const _hoisted_37 = { class: "col-12 fv-row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Pajak", -1)
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-12 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", null, "Informasi Diskon", -1)
const _hoisted_42 = {
  key: 0,
  class: "row px-3"
}
const _hoisted_43 = {
  key: 0,
  class: "col-lg-6 mt-5"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Custom Price")
], -1)
const _hoisted_46 = {
  class: "d-flex",
  style: {"margin-left":"3px"}
}
const _hoisted_47 = {
  key: 0,
  class: "text-center"
}
const _hoisted_48 = {
  key: 0,
  class: "pt-5 ml-5"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-danger",
  style: {"margin-left":"-70px"}
}, "Data Custom Price kosong, silahkan tambah custom price pada fitur sekolah", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  class: "text-danger pt-5",
  style: {"margin-left":"-30px"}
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h4", { class: "pt-10" }, "Data Diskon Kosong", -1)
const _hoisted_53 = {
  key: 0,
  class: "pt-5 m-2"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 1,
  class: "col-lg-12 mt-5"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Custom Price", -1)
const _hoisted_57 = {
  class: "d-flex col-lg-4",
  style: {"margin-left":"3px"}
}
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-lg-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Nama Diskon", -1)
const _hoisted_61 = { class: "col-lg-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Batas Waktu Diskon", -1)
const _hoisted_63 = { class: "col-lg-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Diskon", -1)
const _hoisted_65 = {
  class: "col-lg-2 pb-2 pt-2",
  style: {"align-self":"end"}
}
const _hoisted_66 = {
  key: 1,
  class: "row px-3"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h5", null, " Sekolah Tidak Terpilih, tidak dapat menampilkan custom price ", -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_custom_price",
  ref: "uploadModalRef"
}
const _hoisted_74 = { class: "modal-dialog" }
const _hoisted_75 = { class: "modal-content" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Data Diskon"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_77 = { class: "modal-body" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-lg-12" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Nama Diskon", -1)
const _hoisted_81 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = { class: "col-lg-12" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Batas Waktu Diskon", -1)
const _hoisted_85 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = { class: "col-lg-12" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Diskon", -1)
const _hoisted_89 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "modal-footer" }
const _hoisted_92 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_custom_price123",
  ref: "uploadModalRef"
}
const _hoisted_93 = { class: "modal-dialog" }
const _hoisted_94 = { class: "modal-content" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Custom Price"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_96 = { class: "modal-body" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-lg-12" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Custom Price", -1)
const _hoisted_100 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.editSetting.schoolId == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "schoolId",
                        hidden: "",
                        modelValue: _ctx.editSetting.schoolId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editSetting.schoolId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listSchool, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option._id,
                              label: option.name,
                              value: option._id
                            }, null, 8, _hoisted_12))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.editSetting.schoolId == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.errorsMessage.errorschoolId), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "schoolId",
                        disabled: "",
                        modelValue: _ctx.editSetting.schoolId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editSetting.schoolId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listSchool, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option._id,
                              label: option.name,
                              value: option._id
                            }, null, 8, _hoisted_18))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.editSetting.schoolId == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.errorsMessage.errorschoolId), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  (
                    _ctx.editSetting.title !== 'CUSTOM APLIKASI' &&
                    _ctx.editSetting.title !== 'TOPUP MANUAL' &&
                    _ctx.editSetting.schoolId !== ''
                  )
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "text",
                        name: "title",
                        disabled: "",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Nama Produk",
                        modelValue: _ctx.editSetting.title,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editSetting.title) = $event))
                      }, null, 8, ["modelValue"]))
                    : (_ctx.editSetting.schoolId == '')
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 1,
                          type: "text",
                          name: "title",
                          disabled: "",
                          class: "form-control form-control-lg",
                          placeholder: "Isi Nama Produk",
                          modelValue: _ctx.editSetting.title,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editSetting.title) = $event))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_Field, {
                          key: 2,
                          type: "text",
                          name: "title",
                          disabled: "",
                          class: "form-control form-control-lg",
                          placeholder: "Isi Nama Produk",
                          modelValue: _ctx.editSetting.title,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editSetting.title) = $event))
                        }, null, 8, ["modelValue"])),
                  (_ctx.editSetting.title == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.errorsMessage.errortitle), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "item",
                    modelValue: _ctx.editSetting.item,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editSetting.item) = $event)),
                    disabled: "",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (this.changeProduct()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listProduct, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.id
                        }, null, 8, _hoisted_28))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.editSetting.item == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errorsMessage.erroritem), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  (_ctx.editSetting.schoolId !== '')
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "number",
                        disabled: "",
                        name: "defaultPrice",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Default Price",
                        modelValue: _ctx.editSetting.defaultPrice,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editSetting.defaultPrice) = $event))
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        type: "number",
                        name: "defaultPrice",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Default Price",
                        modelValue: _ctx.editSetting.defaultPrice,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editSetting.defaultPrice) = $event))
                      }, null, 8, ["modelValue"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  (_ctx.editSetting.schoolId !== '')
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "number",
                        disabled: "",
                        name: "expiredInDays",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Batas Waktu (dalam hari)",
                        modelValue: _ctx.editSetting.expiredInDays,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editSetting.expiredInDays) = $event))
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        type: "number",
                        name: "expiredInDays",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Batas Waktu (dalam hari)",
                        modelValue: _ctx.editSetting.expiredInDays,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editSetting.expiredInDays) = $event))
                      }, null, 8, ["modelValue"]))
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  (_ctx.editSetting.schoolId !== '')
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        type: "number",
                        name: "tax",
                        disabled: "",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Pajak (Dalam Percent %)",
                        modelValue: _ctx.editSetting.tax,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editSetting.tax) = $event))
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        type: "number",
                        name: "tax",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Pajak (Dalam Percent %)",
                        modelValue: _ctx.editSetting.tax,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editSetting.tax) = $event))
                      }, null, 8, ["modelValue"]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              (_ctx.editSetting.schoolId != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    (_ctx.editSetting.statusCustomPrice != 'ready')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createElementVNode("div", _hoisted_46, [
                              (
                        _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                        _ctx.editSetting.title == 'TOPUP MANUAL'
                      )
                                ? (_openBlock(), _createBlock(_component_Field, {
                                    key: 0,
                                    type: "number",
                                    disabled: "",
                                    name: "defaultPrice",
                                    class: "form-control form-control-lg",
                                    placeholder: "Isi Custom Price",
                                    modelValue: _ctx.editSetting.pricee,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editSetting.pricee) = $event))
                                  }, null, 8, ["modelValue"]))
                                : (_openBlock(), _createBlock(_component_Field, {
                                    key: 1,
                                    type: "number",
                                    disabled: "",
                                    name: "defaultPrice",
                                    class: "form-control form-control-lg",
                                    placeholder: "Isi Custom Price",
                                    modelValue: _ctx.editSetting.pricee,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editSetting.pricee) = $event))
                                  }, null, 8, ["modelValue"])),
                              (
                        _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                        _ctx.editSetting.title == 'TOPUP MANUAL'
                      )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    style: {"margin-left":"5px"},
                                    hidden: "",
                                    class: "btn btn-warning me-3",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#kt_modal_custom_price123",
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openeditmodal()))
                                  }, " Ubah "))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    style: {"margin-left":"5px"},
                                    class: "btn btn-warning me-3",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#kt_modal_custom_price123",
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openeditmodal()))
                                  }, " Ubah ")),
                              (
                        _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                        _ctx.editSetting.title == 'TOPUP MANUAL'
                      )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 4,
                                    class: "btn btn-danger me-1",
                                    hidden: "",
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleDelete(_ctx.index, _ctx.item)))
                                  }, " Hapus "))
                                : (_ctx.editSetting.pricee != '0')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 5,
                                      class: "btn btn-danger me-1",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleDelete(_ctx.index, _ctx.item)))
                                    }, " Hapus "))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 6,
                                      hidden: "",
                                      class: "btn btn-danger me-1",
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleDelete(_ctx.index, _ctx.item)))
                                    }, " Hapus "))
                            ]),
                            (_ctx.editSetting.pricee == '0')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (
                     _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                     _ctx.editSetting.title == 'TOPUP MANUAL'
                    )
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _hoisted_50))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_51, "Data Custom Price dan Diskon masih kosong silahkan tambahkan data diskon anda"))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _hoisted_52,
                              (
                        _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                        _ctx.editSetting.title == 'TOPUP MANUAL'
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53))
                                : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("button", {
                                      class: "btn btn-success me-3",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#kt_modal_custom_price",
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openaddmodal()))
                                    }, " Tambah ")
                                  ]))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.editSetting.statusCustomPrice == 'ready')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            (
                      _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                      _ctx.editSetting.title == 'TOPUP MANUAL'
                    )
                              ? (_openBlock(), _createBlock(_component_Field, {
                                  key: 0,
                                  type: "number",
                                  disabled: "",
                                  name: "defaultPrice",
                                  class: "form-control form-control-lg",
                                  placeholder: "Isi Default Price",
                                  modelValue: _ctx.editSetting.pricee,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editSetting.pricee) = $event))
                                }, null, 8, ["modelValue"]))
                              : (_openBlock(), _createBlock(_component_Field, {
                                  key: 1,
                                  type: "number",
                                  disabled: "",
                                  name: "defaultPrice",
                                  class: "form-control form-control-lg",
                                  placeholder: "Isi Default Price",
                                  modelValue: _ctx.editSetting.pricee,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editSetting.pricee) = $event))
                                }, null, 8, ["modelValue"])),
                            (
                      _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                      _ctx.editSetting.title == 'TOPUP MANUAL'
                    )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  style: {"margin-left":"5px"},
                                  hidden: "",
                                  class: "btn btn-warning me-3",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#kt_modal_custom_price123",
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openeditmodal()))
                                }, " Ubah "))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  style: {"margin-left":"20px"},
                                  class: "btn btn-warning me-3",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#kt_modal_custom_price123",
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openeditmodal()))
                                }, " Ubah ")),
                            (
                      _ctx.editSetting.title == 'CUSTOM APLIKASI' ||
                      _ctx.editSetting.title == 'TOPUP MANUAL'
                    )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  class: "btn btn-danger me-1",
                                  hidden: "",
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleDelete(_ctx.index, _ctx.item)))
                                }, " Hapus "))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 5,
                                  class: "btn btn-danger me-1",
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleDelete(_ctx.index, _ctx.item)))
                                }, " Hapus "))
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _hoisted_60,
                              _createVNode(_component_Field, {
                                type: "text",
                                name: "namaDiskon",
                                class: "form-control form-control-lg",
                                placeholder: "Isi Nama Diskon",
                                disabled: "",
                                modelValue: _ctx.editSetting.namaDiskon,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editSetting.namaDiskon) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createVNode(_component_Field, {
                                type: "date",
                                name: "expiredDateDiskon",
                                class: "form-control form-control-lg",
                                placeholder: "Isi Tanggal Selesai",
                                disabled: "",
                                modelValue: _ctx.editSetting.expDateDiskon,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editSetting.expDateDiskon) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createVNode(_component_Field, {
                                type: "text",
                                name: "banyakDiskon",
                                class: "form-control form-control-lg",
                                placeholder: "Isi Banyak Diskon (Dalam Percent %)",
                                modelValue: _ctx.editSetting.banyakDiskon,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editSetting.banyakDiskon) = $event)),
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("button", {
                                class: "btn btn-warning me-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#kt_modal_custom_price",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.openeditmodal()))
                              }, " Ubah "),
                              _createElementVNode("button", {
                                class: "btn btn-danger me-1",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.deletePrice()))
                              }, " Hapus ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("button", {
            class: "btn btn-danger me-3",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$router.push('/superadmin/setting-invoices')))
          }, " Kembali "),
          _createElementVNode("button", {
            type: "submit",
            id: "kt_account_profile_details_submit",
            ref: "submitButton",
            class: "btn btn-primary",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveChanges1()))
          }, _hoisted_72, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "namaDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Diskon",
                    modelValue: _ctx.editSetting.namaDiskon,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editSetting.namaDiskon) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSetting.namaDiskon == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.errorsMessage.errornamadiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createVNode(_component_Field, {
                    type: "date",
                    name: "expiredDateDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Selesai",
                    modelValue: _ctx.editSetting.expDateDiskon,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editSetting.expDateDiskon) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSetting.expDateDiskon == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.errorsMessage.errortanggaldiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createVNode(_component_Field, {
                    type: "number",
                    name: "banyakDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Banyak Diskon (Dalam Percent %)",
                    modelValue: _ctx.editSetting.banyakDiskon,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editSetting.banyakDiskon) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.editSetting.banyakDiskon == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.errorsMessage.errorbanyakdiskon), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " Batal "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.saveModal()))
              }, " Simpan ")
            ])
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "namaDiskon",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Custom Price",
                    modelValue: _ctx.editSetting.pricee,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.editSetting.pricee) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " Batal "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.saveModalcustom()))
              }, " Simpan ")
            ])
          ])
        ])
      ], 512)
    ])
  ], 64))
}